module.exports = __webpack_public_path__ + "img/lunbo3.2b2a92ca.jpg";